export default __webpack_public_path__ + "static/media/madrasahReform.d4a2247b.svg";